import React from "react";
import { Link } from "gatsby";

import AbstractHeader from "./AbstractHeader";
import Logo from "../Logo";
import User from "../User";

export default () => (
    <AbstractHeader>
        <Link
            to="/"
            css={{
                height: "100%",
                padding: 15,
                display: "flex",
                alignItems: "center",
            }}
        >
            <Logo />
        </Link>

        <User />
    </AbstractHeader>
);
